export default __webpack_public_path__ + "static/media/img-error-connection.8fa59d40.svg";